export const PERSONAL_DOCUMENT_ALLOWED_EXTENSIONS = [
  ".csv",
  ".xlsx",
  ".xls",
  ".md",
  ".pdf",
  ".txt",
  ".docx",
  ".doc",
  ".pptx",
  ".pptm",
  ".ppt",
  ".msg",
] as const;

export const PERSONAL_DOCUMENT_MAX_FILE_COUNT = 50;

const allowedExtensionSet = new Set<string>(PERSONAL_DOCUMENT_ALLOWED_EXTENSIONS);

export const PERSONAL_DOCUMENT_ACCEPT = PERSONAL_DOCUMENT_ALLOWED_EXTENSIONS.join(",");

export function isPersonalDocumentFileAllowed(fileName: string): boolean {
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex < 0) return false;
  return allowedExtensionSet.has(fileName.slice(lastDotIndex).toLowerCase());
}
